import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';


export interface ListResponse {
  data: [],
  meta: {
    total?: number
  }
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private httpClient: HttpClient,
    private translate: TranslateService
  ) { }
  searchBankaccount(table, data, type = 'admin') {
    const headers = new HttpHeaders({
      'X-Hello-World': 'iloveyou3000'
    });
  
    return this.httpClient.post(`${table}`, data, { headers });
  }
  getList(table, type = 'admin') {
    return this.httpClient.get(`${table}`).pipe(map(d => d['data'] ? d['data'] : d))
  }

  getList2(table, type = 'admin') {
    return this.httpClient.get(`${table}`).pipe(map((d: ListResponse) => d))
  }
  postItem(table, data, type = 'admin') {
    return this.httpClient.post(`${table}`, data)
  }
  addItem(table, data, type = 'admin') {
    return this.httpClient.post(`${table}`, data)
  }
  updateStatus(table, type = 'admin') {
    return this.httpClient.post(`${table}`, type)
  }
  getbyphone(table, data, type = 'admin') {
    return this.httpClient.post(`${table}`, data)
  }
  editItem(table, id, data, type = 'admin') {
    return this.httpClient.put(`${table}/${id}`, data)
  }
  pacth(table, id, data, type = 'admin') {
    return this.httpClient.patch(`${table}/${id}`, data)
  }
  changeStatus(table, id, data, type = 'admin') {
    return this.httpClient.patch(`${table}/${id}`, data)
  }
  patchItem(table, data, type = 'admin') {
    return this.httpClient.patch(`${table}`, data)
  }
  deleteItem(table, id, type = 'admin') {
    return this.httpClient.delete(`${table}/${id}`)
  }

  uploadImage(file) {
    return this.httpClient.post(`media`, file)
  }
  showToast(title = 'Thông báo', text = '', icon, option = { showCancelButton: false, showConfirmButton: false, timer: 2000 }) {
    Swal.fire({
      title,
      text,
      icon,
      ...option,
      // showCancelButton: false,
      // showConfirmButton: false,
      // confirmButtonColor: '#5438dc',
      // cancelButtonColor: '#ff3d60'
    });
  }
  showToastMobile(title, text) {
    Swal.fire({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      icon: title,
      title: text,
      customClass: {
        popup: 'custom-swal-toast'
      }
    });
  }
  successmsg() {
  }
  apiPostToPaydee(path, data) {
    const url = environment.paydeeApiUrl;
    return this.httpClient.post(url + path, data)
  }




  // displayQRCode(user_id: number, amount: number, token: string, mid: string, qr_string: string, bill_number: string) {
  //   const qrpaycode = { user_id: user_id, amount: amount, token: token, mid: mid, qr_string: qr_string, bill_number: bill_number }
  //   return this.httpClient.post('https://paydee-dev.tomotek.vn/api/mbpaybox/display-qr', qrpaycode)
  //   // return this.httpClient.post('https://paydee.tomotek.vn/api/mbpaybox/display-qr', qrpaycode)
  // }

  notiQR(user_id: number, amount: number, token: string, mid: string, noti_type: number) {
    const qrpaycode = { user_id: user_id, amount: amount, token: token, mid: mid, noti_type: noti_type }
    return this.httpClient.post('https://paydee.tomotek.vn/api/mbpaybox/noti', qrpaycode)
  }
}
